import { render, staticRenderFns } from "./UnderPerformingCharts.component.vue?vue&type=template&id=70142b75&scoped=true&"
import script from "./UnderPerformingCharts.component.vue?vue&type=script&lang=js&"
export * from "./UnderPerformingCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./UnderPerformingCharts.component.vue?vue&type=style&index=0&id=70142b75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70142b75",
  null
  
)

export default component.exports